import api from "./api";

class ProgettiManager {

    progetti(config?: any) {
        return api.get(`/progetti`, config)
    }

    progetto(progetto_id: number | string | undefined, config?: any) {
        return api.get(`/progetti/${progetto_id}`, config)
    }

    progettiCreate(data: any) {
        return api.post(`/progetti`, data)
    }

    progettiUpdate(progetto_id: number | string, data: any) {
        return api.put(`/progetti/${progetto_id}`, data)
    }

    myProgetti(config?: any) {
        return api.get(`me/progetti`, config)
    }

    sottoprogetti(progetto_id: number | string | undefined, config?: any) {
        return api.get(`progetti/${progetto_id}/sottoprogetti`, config)
    }

    sottoprogettoCreate(progetto_id: number | string | undefined, data: any) {
        return api.post(`progetti/${progetto_id}/sottoprogetti`, data)
    }

    contattiCliente(progetto_id: number | string | undefined, params = {}){
        return api.get(`progetti/${progetto_id}/contatti`, {params})
    }

}

const progettiManager = new ProgettiManager()

export default progettiManager
